<template>
  <div class="colorFondo">
    <v-container fluid class="white elevation-3 margen d-flex justify-space-around">
      <h1>Requisiciones</h1>

     
      <v-btn class="mt-2 success darken-1" small text to="/crearRequisicion">Nueva Requisicion</v-btn>
    </v-container>

    <v-card class="ma-3 ">
      <v-row class="mx-3 mt-3 mb-3">
        <v-col cols="12" sm="12" md="1" style="overflow-x:hidden">
          <v-btn class="success darken-1 mt-3 mx-auto" small text @click="obtenerRequisiciones()">Actualizar</v-btn>
        </v-col>
        
        <v-col v-if="this.getRolesUsuario.includes('SA') || this.getRolesUsuario.includes('ADMIN')" 
        cols="12" sm="12" md="4" class="d-flex" style="overflow-x:auto">
          <v-checkbox v-model="estatusA" label="Activos" hide-details=""    class="mx-1"></v-checkbox>
          <v-checkbox v-model="estatusP" label="Pendientes" hide-details=""  class="mx-1"></v-checkbox>
          <v-checkbox v-model="estatusC" label="Cancelados/Terminados" hide-details="" class="mx-1"></v-checkbox>
          <!-- <v-checkbox v-model="estatusT" label="Terminados" hide-details="" class="mx-1"></v-checkbox> -->
        </v-col>

        <v-col v-if="this.getRolesUsuario.includes('SA') || this.getRolesUsuario.includes('ADMIN')"
        class="d-flex" cols="12" sm="12" md="4">
          <v-divider vertical class="mx-1"></v-divider>
          <v-checkbox v-model="periodo" label="Periodo" hide-details="" ></v-checkbox>
          <div v-if="periodo"  class="d-flex">
            <v-menu v-model="modalFecha1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field class="ma-auto mx-1" v-model="fechaInicio" label="Inicio" light readonly v-bind="attrs" v-on="on" outlined dense hide-details="" clearable/>
              </template>
              <v-date-picker v-model="fechaInicio" @input="modalFecha1 = false" >
              </v-date-picker>
            </v-menu>

            <span class="ma-auto">a</span>

            <v-menu v-model="modalFecha2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field class="ma-auto mx-1" v-model="fechaFinal" label="Final" light readonly v-bind="attrs" v-on="on" outlined dense hide-details="" clearable/>
              </template>
              <v-date-picker v-model="fechaFinal" @input="modalFecha2 = false" :min="fechaInicio" >
              </v-date-picker>
            </v-menu>
          </div>
          <v-divider vertical class="mx-1" v-if="periodo"></v-divider>
        </v-col>
        
        <v-spacer v-if="!this.getRolesUsuario.includes('SA') || !this.getRolesUsuario.includes('ADMIN')"></v-spacer>
        <v-col cols="12" sm="12" md="3">
          <v-text-field class="ma-3" v-model="buscador" label="Buscar" append-icon="mdi-magnify" single-line hide-details="" />

        </v-col>

      </v-row>

      <v-data-table :headers="columnas" :items="filtrarRequisiciones" :loading="cargando || cargando2" item-class="allB" class="">
      <template v-slot:[`item.ESTATUS`]="{item}">
        <div>
          {{estatus(item.ESTATUS)}}
        </div>
      </template>

      <template v-slot:[`item.FECHA`]="{item}">
        <div>
          {{item.FECHA.split(' ')[0]}}
        </div>
      </template>
      
      <template v-slot:[`item.actionEditar`]="{ item }">
        <div>
          <ModalEditar v-if="articulos.length > 0 && proveedores.length > 0"
          :infoRequisicion ="item"
          :allArticulos ="articulos"
          :allProveedores ="proveedores"
          @actualizarTabla ="obtenerRequisiciones"
          :key="item.REQUISICION_ID"/>
        </div>
      </template>

      <template v-slot:[`item.actionEliminar`]="{ item }">
        <div>
          <ModalEliminar
          :infoRequisicion ="item"
          @actualizarTabla ="obtenerRequisiciones"
          :key="item.REQUISICION_ID"/>
        </div>
      </template>

      <template slot="no-data">
        <v-alert class="my-2" :value="true" type="info" color="orange darken-1" >
          <span class="font-weight-medium"> No se encontro informacion para mostrar.</span>
        </v-alert>
      </template>
      </v-data-table>

      
    </v-card>
  </div>
</template>

<script>

import ModalEditar from './Modals/ModalEditar'
import ModalEliminar from './Modals/ModalEliminar'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  components: { ModalEditar , ModalEliminar},

  data() {
    return {

      buscar: {
                accept: true
            },

      ex4:['primary'],
      requisiciones:[],

      articulos:[],
      proveedores:[],

      buscador:"",
      cargando:false,
      cargando2:false,

      columnas:[
        {text:"Folio",                  value:"FOLIO"         ,divider:true, class:'primary lighten-1 white--text'},
        {text:"Fecha",                  value:"FECHA"         ,divider:true, class:'primary lighten-1 white--text'},
        {text:"Proveedor",              value:"PRNOMBRE", width:'15%',divider:true, class:'primary lighten-1 white--text'},
        {text:"Folio Proyecto",         value:"PFOLIO"        ,divider:true, class:'primary lighten-1 white--text'},
        {text:"Descripcion",            value:"DESCRIPCION"   ,divider:true, class:'primary lighten-1 white--text'},
        {text:"Usuario Creador",        value:"USUARIO_CREADOR"       ,divider:true, class:'primary lighten-1 white--text'},
        {text:"Estatus",                value:"ESTATUS"       ,divider:true, class:'primary lighten-1 white--text'},
        {text:"Editar", sortable:false, value:"actionEditar"  ,divider:true, class:'primary lighten-1 white--text'},
        {text:"Accion", sortable:false, value:"actionEliminar",divider:true, class:'primary lighten-1 white--text'},
        
      ],

      estatusA:true,
      estatusP:false,
      estatusC:false,
      // estatusT:false,

      periodo:false,

      modalFecha1: false,
      modalFecha2: false,

      fechaInicio:"",
      fechaFinal:""
    }
  },

  computed: {
    ...mapGetters(['getURLAPI','getFechaActual','getUsuario','getRolesUsuario']),

    filtrarRequisiciones(){
      return this.requisiciones.filter( (requisicion) => {
        return   requisicion.FOLIO   .toLowerCase().match( this.buscador.toLowerCase() )
              || requisicion.PRNOMBRE.toLowerCase().match( this.buscador.toLowerCase() )
              || requisicion.PFOLIO  .toLowerCase().match( this.buscador.toLowerCase() )
              || requisicion.USUARIO_CREADOR  .toLowerCase().match( this.buscador.toLowerCase() )
              || requisicion.DESCRIPCION  .toLowerCase().match( this.buscador.toLowerCase() )
              || this.estatus(requisicion.ESTATUS).toLowerCase().match( this.buscador.toLowerCase() )
              || requisicion.FECHA.match(this.buscador)
      })
    }
    
  },

  watch: {
    estatusA(){this.obtenerRequisiciones();},
    estatusP(){this.obtenerRequisiciones();},
    estatusC(){this.obtenerRequisiciones();},
    estatusT(){this.obtenerRequisiciones();},
    periodo(){this.obtenerRequisiciones();},
    fechaInicio(){this.obtenerRequisiciones();},
    fechaFinal(){this.obtenerRequisiciones();},
  },

  methods: {
    // ----------------------------------------------------------------------------
    async obtenerRequisiciones(){
      this.requisiciones=[];
      this.cargando = true;
      if (this.getRolesUsuario.includes('SA') || this.getRolesUsuario.includes('ADMIN')) {
        let datosForm = new FormData();
         if (this.estatusA) datosForm.append("ESTATUS_A", this.estatusA);
         if (this.estatusP) datosForm.append("ESTATUS_P", this.estatusP);
         if (this.estatusC) datosForm.append("ESTATUS_C", this.estatusC);
         if (this.periodo) datosForm.append("PERIODO",   this.periodo);
         if (this.fechaInicio) datosForm.append("FECHA_INICIO",   this.fechaInicio);
         if (this.fechaFinal) datosForm.append("FECHA_FIN",   this.fechaFinal);

        this.requisiciones = (await axios.post(`${this.getURLAPI}/Requisiciones/mostrarRequisiciones`,datosForm)).data
        // console.log(this.requisiciones);
        
      } else {
        let datosForm = new FormData();
        datosForm.append("USUARIO_CREADOR", this.getUsuario);
        //  if (this.estatusA) datosForm.append("ESTATUS_A", this.estatusA);
        //  if (this.estatusP) datosForm.append("ESTATUS_P", this.estatusP);
        //  if (this.estatusC) datosForm.append("ESTATUS_C", this.estatusC);
        //  if (this.periodo)  datosForm.append("PERIODO",   this.periodo);
        //  if (this.fechaInicio) datosForm.append("FECHA_INICIO",   this.fechaInicio);
        //  if (this.fechaFinal) datosForm.append("FECHA_FIN",   this.fechaFinal);

        this.requisiciones = (await axios.post(`${this.getURLAPI}/Requisiciones/mostrarRequisicionesUsuario`,datosForm)).data
      }
      // console.log(this.requisiciones)
      this.cargando = false;
      
    },

    // ----------------------------------------------------------------------------
    editarRequisicion( requisicion ){
      this.requisicion = requisicion;
      this.mostrarModal = true;
    },

    // ----------------------------------------------------------------------------
    claseItem(item){
      if (!item) return
      return "mouse"
    },
    
    // ----------------------------------------------------------------------------
    estatus( ESTATUS ){
      if( ESTATUS == 'A'){
        return 'Activo'
      }else if( ESTATUS == 'B'){
        return 'Baja'
      }else if( ESTATUS == 'P'){
        return 'Pendiente'
      }
      return 'N/A'
    },

     // -----------------------------------------------------------------------------
    async getArticulos() {
      this.cargando2 = true;
      // console.time("articulos");
      // this.cargando = true;
      this.articulos = [];

      this.articulos = ( await axios.get(`${this.getURLAPI}/Show/allArticles`)).data;
      this.articulos.forEach((articulo) => {
        articulo.CANTIDAD = 1;
      });
      // console.log(this.articulos);
      // this.cargando = false;
      this.cargando2 = false;
      // console.timeEnd("articulos");
    },
    // ---------------------------------------------------------------------------
    async getProveedores(){
      this.proveedores = (await axios.get(`${this.getURLAPI}/Show/allProveedores`)).data
    },
  },

  created() {
    document.title = "Requisiciones | Bombas y Suministros del Norte";
    this.obtenerRequisiciones();
    this.getArticulos();
    this.getProveedores();
  },
}
</script>

<style>
@media screen and (max-width : 425px){
  #mobil{
    font-size: small;
    word-break: inherit!important;
  }
}
.mouse{
  cursor: pointer!important;
}
</style>